import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import AuthLayout from 'components/Auth/Layout';
import routes from 'routes';

import ForgotPasswordForm from './components/ForgotPasswordForm';

@inject('authStore', 'userStore', 'routingStore')
@observer
class ForgotPasswordPage extends Component {
  componentDidMount() {
    const {
      authStore: { isAuthenticated },
      routingStore: { replace },
    } = this.props;

    if (isAuthenticated) {
      replace(routes.home);
    }
  }

  render() {
    const {
      authStore: { onForgotPassword },
    } = this.props;
    return (
      <AuthLayout image="/images/backgrounds/forgotPassword.png">
        <ForgotPasswordForm onSubmit={onForgotPassword} />
      </AuthLayout>
    );
  }
}

export default ForgotPasswordPage;
